import { Dispatch } from 'redux';

import { ThunkAction } from '@tmapy/redux';

import { ordersRetryProcessingPartialUpdate } from '../../openapi/operations/ordersRetryProcessingPartialUpdate';
import { ordersInterruptProcessingPartialUpdate } from '../../openapi/operations/ordersInterruptProcessingPartialUpdate';

import * as con from '../constants';

export const orderRetryProcessing =
  (orderId: number): ThunkAction =>
  async (dispatch: Dispatch) => {
    dispatch({
      type: con.ORDER_RETRY_PROCESSING_WAITING,
      orderId,
    });

    const response = await ordersRetryProcessingPartialUpdate({
      query: { id: orderId },
      request: {},
    });

    if (response.ok) {
      dispatch({
        type: con.ORDER_RETRY_PROCESSING_SUCCESS,
        data: response.data,
      });
    } else {
      dispatch({
        type: con.ORDER_RETRY_PROCESSING_FAILURE,
      });
    }

    return response;
  };

export const orderInterruptProcessing =
  (orderId: number): ThunkAction =>
  async (dispatch: Dispatch) => {
    dispatch({
      type: con.ORDER_INTERRUPT_PROCESSING_WAITING,
      orderId,
    });

    const response = await ordersInterruptProcessingPartialUpdate({
      query: { id: orderId },
      request: {},
    });

    if (response.ok) {
      dispatch({
        type: con.ORDER_INTERRUPT_PROCESSING_SUCCESS,
        data: response.data,
      });
    } else {
      dispatch({
        type: con.ORDER_INTERRUPT_PROCESSING_FAILURE,
      });
    }

    return response;
  };
